<template>
  <div class="shadow-lg topbar py-3">
    <div class="page-container flex justify-between items-center">
      <div class="site-logo flex items-center">
        <router-link :to="homeURL()" class="block">
          <img
            width="200"
            height="123"
            class="w-20 md:w-28"
            :class="$route.path === '/' ? 'lg:invisible' : ''"
            :src="logoURL()"
            alt="YKA"
          />
        </router-link>

        <span
          v-if="$route.name == 'FEP' && $store.state.localSettings"
          class="logo-title hidden sm:block font-thin ml-4 text-base text-gray text-left text-xs heading-font"
        >
          Draft in
          <b class="font-semibold">{{ $store.state.localSettings.name }}</b>
        </span>
      </div>
      <div class="topbar-buttons" role="navigation">
        <ul class="flex items-center">
          <li className="hidden lg:block">
            <TopMenu />
          </li>
          <li class="search-icon">
            <router-link to="/search/" class="block">
              <Icon class="h-6 w-6 text-yka-blue" name="search" />
            </router-link>
          </li>
          <li class="btn-hindi" v-if="!$store.state.localSettings">
            <a
              href="#login"
              data-behaviour="login-redirect-newsfeed"
              class="ui-font button bg-yka-blue text-white"
              >Sign-in</a
            >
          </li>
          <template v-if="$store.state.localSettings">
            <li class="btn-hindi">
              <router-link to="/me" class="button text-yka-blue ui-font"
                >Write</router-link
              >
            </li>
          </template>

          <li class="hamburger block lg:hidden">
            <SideMenu />
          </li>
          <li>
            <UserMenu />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icons.vue";
import SideMenu from "@/components/header/SideMenu.vue";
import UserMenu from "@/components/header/UserMenu.vue";
import TopMenu from "@/components/header/TopMenu.vue";

import store from "@/store";

export default {
  components: {
    SideMenu,
    UserMenu,
    Icon,
    TopMenu,
  },

  setup() {
    const logoURL = () => process.env.VUE_APP_LOGO_URL;

    const homeURL = () =>
      store.state?.localSettings?.id ? { name: "Newsfeed" } : { name: "Home" };

    return {
      homeURL,
      logoURL,
    };
  },
};
</script>

<style scoped>
.topbar-buttons .button {
  @apply block text-sm border-2 border-yka-blue rounded-full py-1 px-4;
}

.topbar-buttons li {
  @apply ml-2 md:ml-3;
}

@media (max-width: 375px) {
  .topbar-buttons .hide-btn-hindi {
    display: none;
  }
}
</style>
